import { Injectable } from '@angular/core';


import { NavController, Platform } from '@ionic/angular';
import { StorageManagerProvider } from '../storage-manager/storage-manager';
import { UserManagerProvider } from '../user-manager/user-manager';
import { SocketManagerProvider } from '../socket-manager/socket-manager';
import { ACTIONS, SETTINGS } from '../../bayadic-shared-models/enums/Enums';
import { UpdateSettingResponse } from '../../bayadic-shared-models/item/update-setting-response';
import { UpdateSettingRequest } from '../../bayadic-shared-models/item/update-setting-request';
import { LoggerService } from '../../app/services/logger.service';
@Injectable()
export class NotificationsManagerProvider {

  constructor(
    public storageManager: StorageManagerProvider,
    public userManager: UserManagerProvider,
    public socketManager: SocketManagerProvider,
    public platform: Platform,
    public logger: LoggerService
  ) {
  }
  async saveNotificationOnline(status: boolean){
    await this.storageManager.set(SETTINGS.notificationEnable, status);

    const result = await this.socketManager.asyncQuery<UpdateSettingResponse, UpdateSettingRequest>
    (ACTIONS.updateSetting, {
      key: SETTINGS.notificationEnable, value: status.toString()}
    );
  }

}
